import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { setAccount } from "../../store/panel";
import { ButtonBase, InputBase } from "../../../common/components/form";
import * as API from "../../lib/api";
import * as Links from "../../lib/links";

export default function PasswordRecovery() {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const history = useHistory();

    const [mainError, setMainError] = React.useState(null);
    const [processing, setProcessing] = React.useState(false);
    const [complete, setComplete] = React.useState(false);
    const [fields, setFields] = React.useState({ password: "", password2: "" });
    const [errors, setErrors] = React.useState({});

    function onChange(event) {
        let { name, value } = event.target;
        setFields({ ...fields, [name]: value });

        const _errors = { ...errors };

        switch (name) {
            case "password":
                _errors[name] = null;

                if (!value) {
                    _errors[name] = "ErrorFieldPasswordEnter";
                    _errors.password2 = null;
                } else if (value.length < 6) {
                    _errors[name] = "ErrorFieldPasswordTooShort";
                    _errors.password2 = null;
                } else if (!fields.password2 || !fields.password2) {
                    _errors.password2 = "ErrorFieldPasswordConfirm";
                    _errors[name] = null;
                } else if (value !== fields.password2) {
                    _errors[name] = "ErrorFieldPasswordsDoNotMatch";
                    _errors.password2 = "ErrorFieldPasswordsDoNotMatch";
                }

                break;

            case "password2":
                _errors[name] = null;
                _errors.password = null;

                if (!fields.password || _errors.password) {
                    _errors[name] = null;
                } else if (!value || !value) {
                    _errors[name] = "ErrorFieldPasswordConfirm";
                } else if (value !== fields.password) {
                    _errors[name] = "ErrorFieldPasswordsDoNotMatch";
                    _errors.password = "ErrorFieldPasswordsDoNotMatch";
                }

                break;
        }

        setFields({ ...fields, [name]: value });
        setErrors(_errors);
    }

    function onResetClick() {
        setMainError(null);
        setProcessing(true);

        return API.AccountSetPassword({ password: fields.password })
            .then(account => {
                if (!account?.ok) {
                    setMainError("UnknownError");
                    return null;
                }

                delete account.ok;

                return account;
            })
            .then(account => {
                setComplete(!!account);

                account &&
                    setTimeout(() => {
                        dispatch(setAccount(account));
                        history.push(Links.Dashboard());
                    }, 500);
            })
            .finally(() => setProcessing(false));
    }

    function onSubmit(event) {
        event.preventDefault();
    }

    function errorByField(fieldname) {
        return errors[fieldname] ? t(errors[fieldname]) : null;
    }

    const allowNext =
        Object.values(errors).filter(v => v).length === 0 &&
        (() => {
            for (const [key, value] of Object.entries(fields)) {
                if (!value) {
                    return false;
                }
            }

            return true;
        })();

    const CNPanelLogin = ["password-recovery"];
    processing && CNPanelLogin.push("processing");
    complete && CNPanelLogin.push("complete");

    return (
        <div className={CNPanelLogin.join(" ")}>
            <form action="#" onSubmit={onSubmit}>
                <div className="password-recovery-fields">
                    <h1>{t("PasswordSetting")}</h1>

                    <div className="margin-top-40">
                        <div>
                            <InputBase
                                name="password"
                                type="password"
                                onChange={onChange}
                                value={fields.password || ""}
                                placeholder={t("Password")}
                            />

                            <p className="field-message color-error">{errorByField("password") || <>&nbsp;</>}</p>
                        </div>

                        <div>
                            <InputBase
                                name="password2"
                                type="password"
                                onChange={onChange}
                                value={fields.password2 || ""}
                                placeholder={t("PasswordConfirm")}
                            />

                            <p className="field-message color-error">{errorByField("password2") || <>&nbsp;</>}</p>
                        </div>
                    </div>

                    <p className="field-message color-error">{mainError ? t(mainError) : <>&nbsp;</>}</p>
                </div>

                <div className="password-recovery-buttons margin-top-40">
                    <ButtonBase invert type="submit" onClick={onResetClick} disabled={!allowNext}>
                        {t("Continue")}
                    </ButtonBase>
                </div>
            </form>
        </div>
    );
}
